import { LocaleAuth } from '../en/auth'

const auth: LocaleAuth = {
  heading: '为了运动',
  signIn: '登陆',
  forgotPass: '忘记密码？',
  claimQuestion: '只是在锦标赛中？',
  claimAccount: '找回您的账户',
  claimAccountDesc: '已经参加过锦标赛或联赛？您可能已经有一个个人档案和一个DUPR等级。',
  signUp: '注册',
  createAccount: '创建账户',
  createPassword: '创建密码',
  passInstructLength: '长度必须至少为6个字符',
  passInstructStructure: '必须包含一个或多个数字',
  forgotPassDesc: '输入您的注册电子邮件，以接收如何重置密码的说明。',
  checkYourEmail: '检查你的电子邮件！',
  resetCodeSentGeneric: '如果该地址存在账户，我们已发送 4 位数代码。',
  verifyEmailDesc: '您刚刚获得了一个通过电子邮件重置密码的代码。输入4位数代码继续。',
  verifyYourNumber: '验证您的号码',
  verifyPhoneNumberDesc: '一个4位数的代码已发送到您的电话号码，请在此处输入以进行验证。',
  claimAccountHelpText: '在搜索栏中键入您的姓名，开始搜索您的结果',
  notSeeYourself: '在这里看不到自己？',
  lastMatch: '最后一场比赛',
  noMatchResult: '没有比赛结果',
  accAlreadyTaken: '这个账户已经被使用了',
  accAlreadyTakenModal: '如果您认为这是您的账号，但是被其他人使用了您的帐户，请联系我们的咨询团队',
  noAccount: '没有DUPR帐户？',
  iAgreeToThe: '我同意',
  termsOfService: '服务条款',
  privacyPolicy: '隐私政策',
  acceptTerms: '请接受服务条款以继续',
  cookiePolicy: 'Cookie 政策',
}

export default auth
